import { Component, OnInit, ComponentFactoryResolver, ChangeDetectorRef, ViewChild, ElementRef, Input, Output, EventEmitter } from '@angular/core';
import { FormController } from '../../../../framework/controllers/FormController';
import { ApiService } from '@services/api/api.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { ActivatedRoute } from '@angular/router';
import { BreadCrumbsService } from '@services/bread-crumbs/bread-crumbs.service';
import { NestedNavigationService } from '../../../../services/nested-navigation/nested-navigation.service';
import { ToolbarActionsService } from '../../../../services/toolbar-actions/toolbar-actions.service';
import { ToastrService } from 'ngx-toastr';
import { MatDialog } from '@angular/material/dialog';
import { IFieldOptions } from '../../../interfaces/IEntity';
declare var WacomGSS_SignatureSDK;

@Component({
  selector: 'app-mfcustom-signature',
  templateUrl: './mfcustom-signature.component.html',
  styleUrls: ['./mfcustom-signature.component.css']
})
export class MfCustomSignatureComponent implements OnInit {
  @Output() public dataChange = new EventEmitter();
  @Output() public dataObjChange = new EventEmitter();
  public loading: boolean;
  public imgSource: any;
  public port = 8000;
  private yesNoControl: any;
  private datestampControl: any;
  private wgssSignatureSDK;
  private _data;
  private signatureDescription;
  public timeout;
  @Input() public dataObj: any;
  @Input() public fieldOptions: IFieldOptions;
  @Input() public references: any;
  @Input() public name = "John Doe";
  @Input() public title = "Test signatures";
  @Input() public get data() {
    return this._data;
  } public set data(value) {
    this._data = value;
    this.loadData();
  }
  public date;
  public statusText;
  private licenseKey;
  public tabletFound: boolean;
  public showTutorial: boolean = true;
  private digitalCabinetDocumentId: any;
  public get signatureTooltip() {
    return this.imgSource ? this.signatureDetails : 'No signature captured';
  }
  public get signatureDetails() {
    if (this.signatureDescription)
      return this.signatureDescription;
    return 'Signed on ' + this.date + ' by ' + this.name + ' for ' + this.title;
  }
  @Input() public width: any = 220;
  @Input() public height: any = 110;
  // pass the starting service port  number as configured in the registry
  //var wgssSignatureSDK;
  constructor(public apiService?: ApiService,
    messageService?: ToastrService,
    dialogService?: MatDialog,
    private auth?: IdentityAuthService,
    private cdr?: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.licenseKey = this.auth.wacomKey.substr(0, 44) + this.auth.wacomKey.substr(56, this.auth.wacomKey.length - 44 - 12);
    if (this.fieldOptions && this.fieldOptions.extraData) {
      if (this.fieldOptions.extraData.yesNoControl)
        this.yesNoControl = this.fieldOptions.extraData.yesNoControl;
      if (this.fieldOptions.extraData.datestampControl)
        this.datestampControl = this.fieldOptions.extraData.datestampControl;

    }
  }
  ngAfterViewInit() {
    var _th = this;
    this.timeout = setTimeout(function () {
      if (_th.wgssSignatureSDK.running) {
        _th.statusText = "Signature SDK Service detected";
        _th.tabletFound = true;
        _th.showTutorial = false;
      }
      else {
        _th.tabletFound = false;
        _th.showTutorial = true;
        if (_th.wgssSignatureSDK.service_detected) {
          _th.statusText = "SigCaptX service detected, but not the server";
        }
        else {
          _th.statusText = "SigCaptX service not detected";
        }
      }
    }, 1500);
    _th.wgssSignatureSDK = new WacomGSS_SignatureSDK(function () {
      _th.statusText = "Signature SDK Service detected";
      _th.tabletFound = true;
      _th.showTutorial = false;
      clearTimeout(_th.timeout);
    }, 8000)
  }
  print(txt) {
    this.statusText += txt + "\n";
  }

  uploadSignature() {
    this.signatureDescription = null;
    this.loading = true;
    var curRef = this.references;
    while (curRef != null) {
      curRef.description = this.signatureDetails;
      if (curRef.digitalCabinet)
        curRef = curRef.digitalCabinet;
      else curRef = null;
    }
    this.cdr.detectChanges();
    this.apiService.post("/api/digitalCabinet/uploadSignature", {
      fileData: this.imgSource, digitalCabinet: this.references, fileName: new Date()["shortDateNum"]() + '.jpeg', digitalCabinetDocumentId: this.digitalCabinetDocumentId
    })
      .subscribe(data => {
        this.loading = false;
        this.digitalCabinetDocumentId = data.digitalCabinetDocumentId;
        this._data = this.digitalCabinetDocumentId;
        this.dataChange.emit(this._data);
        if (this.yesNoControl)
          this.dataObj[this.yesNoControl.id] = true;
        if (this.datestampControl)
          this.dataObj[this.datestampControl.id] = this.date;
        this.cdr.detectChanges();
      },
        err => {
          this.loading = false;
          this.cdr.detectChanges();
        })
  }

  loadData() {
    this.loading = true;
    this.signatureDescription = null;
    this.imgSource = null;
    this.cdr.detectChanges();
    this.apiService.post("/api/digitalCabinet/getSignature", this.references)
      .subscribe(data => {
        if (data.length > 0) {
          this.digitalCabinetDocumentId = data[0].digitalCabinetDocumentId
          this._data = this.digitalCabinetDocumentId;
          this.dataChange.emit(this._data);
          this.signatureDescription = data[0].description;
          this.apiService.get('/api/digitalCabinet/getImageBase64/' + this.digitalCabinetDocumentId)
            .subscribe(base64 => {
              this.imgSource = 'data:image/jpg;base64,' + base64;
              this.loading = false;
              this.cdr.detectChanges();
            });
        }
        else {
          this.loading = false;
          this.cdr.detectChanges();
        }
      },
        err => {
          this.loading = false;
          this.cdr.detectChanges();
        })
  }

  captureSignature() {
    var self = this;

    var sigObj;
    var sigCtl;
    var dynCapt;
    if (this.fieldOptions.action)
      this.name = this.fieldOptions.action(this.dataObj);
    function restartSession(onRestartSession) {
      self.statusText += "<br>Restarting the session";
      self.wgssSignatureSDK = new WacomGSS_SignatureSDK(onRestartSession, 8000)
    }

    function displaySignatureDetails() {
      if (!self.wgssSignatureSDK.running || null == sigObj) {
        self.print("Session error. Restarting the session.");
        return;
      }
      sigObj.GetIsCaptured(onGetIsCaptured);

      function onGetIsCaptured(sigObj, isCaptured, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          if (!isCaptured) {
            self.print("No signature has been captured yet.");
            return;
          }
          sigObj.GetWho(onGetWho);
        }
        else {
          self.print("Signature GetWho error: " + status);
          if (self.wgssSignatureSDK.ResponseStatus.INVALID_SESSION == status) {
            self.print("Session error. Restarting the session.");
          }
        }
      }

      function onGetWho(sigObjV, who, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          self.print("<br>  Name:   " + who);
          var tz = self.wgssSignatureSDK.TimeZone.TimeLocal;
          sigObj.GetWhen(tz, onGetWhen);
        }
        else {
          self.print("Signature GetWho error: " + status);
        }
      }

      function onGetWhen(sigObjV, when, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          self.print("<br>  Date:   " + when.toString());
          self.date = when;
          sigObj.GetWhy(onGetWhy);
        }
        else {
          self.print("Signature GetWhen error: " + status);
        }
      }

      function onGetWhy(sigObjV, why, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          self.print("<br>  Reason: " + why);
          self.uploadSignature();
        }
        else {
          self.print("Signature GetWhy error: " + status);
        }
      }
    }

    function onHashConstructor(hashV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        GetHash(hash, onGetInitialHash);
      }
      else {
        self.statusText += "<br>Hash Constructor error: " + status;
        if (self.wgssSignatureSDK.ResponseStatus.INVALID_SESSION == status) {
          self.statusText += "<br>Error: invalid session.";
        }
      }
    }
    function onGetInitialHash() {
      dynCapt = new self.wgssSignatureSDK.DynamicCapture(onDynCaptConstructor)
    }
    function GetHash(hash, callback) {
      //self.statusText += "<br>Creating hash:";
      hash.Clear(onClear);

      function onClear(hashV, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          hash.PutType(self.wgssSignatureSDK.HashType.HashMD5, onPutType);
        }
        else {
          self.statusText += "Hash Clear error: " + status;
        }
      }

      function onPutType(hashV, status) {
        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          var vFname = new self.wgssSignatureSDK.Variant();
          vFname.Set(self.name);
          hash.Add(vFname, onAddLname);
        }
        else {
          self.statusText += "<br>Hash PutType error: " + status;
        }
      }

      function onAddLname(hashV, status) {

        if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
          if (callback)
            callback();
        }
        else {
          self.statusText += "<br>Hash Add error: " + status;
        }
      }
    }


    function onPutSigData(sigObjV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        self.statusText += "<br>PutSigData called";
      }
      else {
        self.statusText += "<br>error on PutSigData: " + status;
      }
    }

    function onGetSigText(sigObjV, data, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        self.statusText += "<br>SigText: " + data;
        var vData = new self.wgssSignatureSDK.Variant();
        vData.type = self.wgssSignatureSDK.VariantType.VARIANT_BASE64;
        vData.base64 = data;
        sigObjV.PutSigData(vData, onPutSigData);
      }
      else {
        self.statusText += "<br>error on GetSigData: " + status;
      }
    }

    function onGetAdditionalData(sigObjV, additionalData, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        //self.statusText += "<br>Additional Data/MachineOS: " + additionalData;
        //sigObjV.GetSigText(onGetSigText);
      }
      else {
        self.statusText += "<br>error on GetAdditionalData: " + status;
      }
    }

    function onRenderBitmap(sigObjV, bmpObj, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        if (bmpObj.isBase64) {
          self.imgSource = bmpObj.image.src
          self.cdr.detectChanges();
          //self.statusText += "<br>Base64 bitmap retrieved:<br>";
          //self.statusText += "<br>" + bmpObj.image.src;
        }
        else {
          self.statusText += "<br>Bitmap retrieved, rendering image...";
        }
        // self.ctx.drawImage(bmpObj.image, 0, 0);
        sigObjV.GetAdditionalData(self.wgssSignatureSDK.CaptData.CaptMachineOS, onGetAdditionalData);
      }
      else {
        self.statusText += "<br>Signature Render Bitmap error: " + status;
      }
    }

    function onPutExtraData(sigObjV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        //self.statusText += "<br>Rendering bitmap";
        var flags = self.wgssSignatureSDK.RBFlags.RenderOutputPicture |
          self.wgssSignatureSDK.RBFlags.RenderColor24BPP;
        sigObjV.RenderBitmap("bmp", self.width, self.height, 0.7, 0x00000000, 0x00FFFFFF, flags, 0, 0, onRenderBitmap);
        sigObj = sigObjV;

        verifySignedData();
      }
      else {
        self.statusText += "<br>Signature PutExtraData error: " + status;
      }
    }

    function onDynCaptCapture(dynCaptV, sigObjV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        // self.statusText += "<br>Adding extra data";
        sigObjV.PutExtraData("extra key", "extra value", onPutExtraData);
      }
      else if (1 == status) {
        self.statusText += "<br>Signature capture cancelled by the user";
      }
      else {
        if (self.wgssSignatureSDK.DynamicCaptureResult.DynCaptPadError == status)
          self.statusText += "<br>Signature capture error: Pad not found";
        else if (self.wgssSignatureSDK.DynamicCaptureResult.DynCaptNotLicensed == status)
          self.statusText += "<br>Signature capture error: License is not valid";
      }
    }

    function onSigCtlPutLicence(sigCtlV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        dynCapt.Capture(sigCtlV, self.name, self.title, hash, null, onDynCaptCapture);
      }
      else {
        self.statusText += "<br>SigCtl constructor error: " + status;
      }
    }

    function onSigCtlConstructor(sigCtlV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        sigCtlV.PutLicence(self.licenseKey, onSigCtlPutLicence);
      }
      else {
        self.statusText += "<br>SigCtl constructor error: " + status;
      }
    }

    function onDynCaptConstructor(dynCaptV, status) {
      if (self.wgssSignatureSDK.ResponseStatus.OK == status) {
        sigCtl = new self.wgssSignatureSDK.SigCtl(onSigCtlConstructor);
      }
      else {
        self.statusText += "<br>Dynamic Capture constructor error: " + status;
        if (WacomGSS_SignatureSDK.ResponseStatus.INVALID_SESSION == status) {
          restartSession(self.captureSignature);
        }
      }
    }

    function verifySignedData() {
      //self.statusText += "<br>Verifying signed data...";
      if (null == sigObj) {
        return;
      }
      sigObj.GetIsCaptured(onGetHashForVerification);

      function onGetHashForVerification() {
        sigObj.CheckSignedData(hash, onCheckSignedData);
      }
      function onCheckSignedData(hash, status) {
        //self.statusText += "<br>Verify result: " + status;
        if (self.wgssSignatureSDK.SignedData.DataGood == status) {
          //self.statusText += "<br>Signed Data OK";
          displaySignatureDetails();

        }
        else {
          self.statusText += "<br>Signed Data Has Changed";
        }
      }
    }
    if (self.wgssSignatureSDK.running) {
      var hash = new self.wgssSignatureSDK.Hash(onHashConstructor);
    }
  }
}
